var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.assignModule == 5)?_c('div',[_c('DoctorDashboard')],1):(_vm.assignModule == 3)?_c('div',[_c('Dashboard')],1):(_vm.assignModule == 2)?_c('div',[_c('MedtechDashboard')],1):(_vm.assignModule == 7)?_c('div',[_c('CashierDashboard')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }